// Feature images - these would need to be imported from actual image assets

import { featureImages } from "../components/images/jpg/featureImgaes";


export const featuresData = [
    {
        titleKey: 'FEATURES_COMBINE_INVOICE_TITLE',
        descriptionKey: 'FEATURES_COMBINE_INVOICE_DESCRIPTION',
        para1: 'FEATURES_COMBINE_INVOICE_PARAGRAPH',
        para2: 'FEATURES_COMBINE_INVOICE_PARAGRAPH_2',
        image: featureImages.combineInvoice
    },
    {
        titleKey: 'FEATURES_HOLIDAY_COMPENSATION_TITLE',
        descriptionKey: 'FEATURES_HOLIDAY_COMPENSATION_DESCRIPTION',
        para1: 'FEATURES_HOLIDAY_COMPENSATION_PARAGRAPH',
        para2: 'FEATURES_HOLIDAY_COMPENSATION_PARAGRAPH_2',
        image: featureImages.holidayCompensation
    },
    {
        titleKey: 'FEATURES_EXPRESS_PAYMENT_TITLE',
        descriptionKey: 'FEATURES_EXPRESS_PAYMENT_DESCRIPTION',
        para1: 'FEATURES_EXPRESS_PAYMENT_PARAGRAPH',
        para2: 'FEATURES_EXPRESS_PAYMENT_PARAGRAPH_2',
        image: featureImages.expressPayment
    },
    {
        titleKey: 'FEATURES_MULTIPLE_CURRENCIES_TITLE',
        descriptionKey: 'FEATURES_MULTIPLE_CURRENCIES_DESCRIPTION',
        para1: 'FEATURES_MULTIPLE_CURRENCIES_PARAGRAPH',
        para2: 'FEATURES_MULTIPLE_CURRENCIES_PARAGRAPH_2',
        image: featureImages.multipleCurrencies
    },
        {
        titleKey: 'FEATURES_PERSONALIZE_LOGO_TITLE',
        descriptionKey: 'FEATURES_PERSONALIZE_LOGO_DESCRIPTION',
        para1: 'FEATURES_PERSONALIZE_LOGO_PARAGRAPH',
        para2: 'FEATURES_PERSONALIZE_LOGO_PARAGRAPH_2',
        image: featureImages.personalizelogo
    },
    {
        titleKey: 'FEATURES_AGREEMENT_OFFERS_TITLE',
        descriptionKey: 'FEATURES_AGREEMENT_OFFERS_DESCRIPTION',
        para1: 'FEATURES_AGREEMENT_OFFERS_PARAGRAPH',
        para2: 'FEATURES_AGREEMENT_OFFERS_PARAGRAPH_2',
        image: featureImages.agreementOffers
    },
    {
        titleKey: 'FEATURES_PRELIMINARY_INVOICE_TITLE',
        descriptionKey: 'FEATURES_PRELIMINARY_INVOICE_DESCRIPTION',
        para1: 'FEATURES_PRELIMINARY_INVOICE_PARAGRAPH',
        image: featureImages.preliminaryInvoice
    },
    {
        titleKey: 'FEATURES_TIME_REPORTS_TITLE',
        descriptionKey: 'FEATURES_TIME_REPORTS_DESCRIPTION',
        para1: 'FEATURES_TIME_REPORTS_PARAGRAPH',
        para2: 'FEATURES_TIME_REPORTS_PARAGRAPH_2',
        para3: 'FEATURES_TIME_REPORTS_PARAGRAPH_3',
        image: featureImages.timeReports
    },
    {
        titleKey: 'FEATURES_VAT_RATE_TITLE',
        descriptionKey: 'FEATURES_VAT_RATE_DESCRIPTION',
        para1: 'FEATURES_VAT_RATE_PARAGRAPH',
        para2: 'FEATURES_VAT_RATE_PARAGRAPH_2',
        para3: 'FEATURES_VAT_RATE_PARAGRAPH_3',
        image: featureImages.vatRate
    },
    {
        titleKey: 'FEATURES_FOREIGN_BANK_TITLE',
        descriptionKey: 'FEATURES_FOREIGN_BANK_DESCRIPTION',
        para1: 'FEATURES_FOREIGN_BANK_PARAGRAPH',
        para2: 'FEATURES_FOREIGN_BANK_PARAGRAPH_2',
        para3: 'FEATURES_FOREIGN_BANK_PARAGRAPH_3',
        image: featureImages.foreignBank
    },
    {
        titleKey: 'FEATURES_RUT_ROT_TITLE',
        descriptionKey: 'FEATURES_RUT_ROT_DESCRIPTION',
        para1: 'FEATURES_RUT_ROT_PARAGRAPH',
        para2: 'FEATURES_RUT_ROT_PARAGRAPH_2',
        para3: 'FEATURES_RUT_ROT_PARAGRAPH_3',
        para4: 'FEATURES_RUT_ROT_PARAGRAPH_4',
        image: featureImages.rutRot
    }
];
